module.exports = __webpack_public_path__ + "static/media/tf1.9291fa32.png";